import React from 'react';
import clsx from 'clsx';
import styles from './Field.module.scss';

type Props = {
  htmlFor?: string;
  label?: string;
  className?: string;
  children: React.ReactNode;
  required?: boolean;
  id?: string;
  style?: any; 
};

const Field = React.forwardRef<HTMLDivElement, Props>((props, ref): JSX.Element => {
  const {
    htmlFor,
    label,
    className,
    children,
    required,
    id,
    style,
    ...other
  } = props;

  return (
    <div
      id={id}
      ref={ref}
      className={clsx(styles.container, className)}
      style={style}
      {...other}
    >
      {label && <label htmlFor={htmlFor} className={styles.label}>{label} {required && <p className={styles.requiredLabelText}>[必須]</p>}</label>}
      <div className={styles.contents}>
        {children}
      </div>
    </div>
  );
});

export default React.memo(Field);
